import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MDS_COLORS_INK_ACCENT_HOVER, MDS_COLORS_INK_DEFAULT, MDS_COLORS_INK_ERROR, MDS_COLORS_INK_POSITIVE, MDS_COLORS_INK_RECOMMENDATION, MDS_COLORS_INK_WEAK, } from '@rappi/mustache-b2b-foundations';
import { Button, CancelCircleIcon, CheckInsideCircleOutlineIcon, CircleAlertOutlineIcon, FlexContainer, Loader, PaperDownloadOutlineIcon, SparklesIcon, Typography, UploadOutlineIcon, } from '@rappi/rests-commons-front';
import { useRef, useState } from 'react';
import { CloseButton, Container, ContentContainer, IconContainer, Label } from './styles';
export const FileUploaderInline = ({ id, label, rules, onFileChange, onRemove, disabled, file, aiScrapper, text = {
    hoverText: 'Suelta el archivo aquí',
    loadingText: 'Este proceso puede tardar hasta 2 minutos.',
    errorWeightText: 'El archivo pesa demasiado.',
    errorFileText: 'El archivo no es válido.',
    selectButtonText: 'Seleccionar',
    loadingTextAiScrapper: 'Rellenando formulario con IA',
    errorExecutionText: 'Hubo un error al procesar el archivo.',
}, }) => {
    var _a, _b, _c;
    const inputRef = useRef(null);
    const [state, setState] = useState(file ? 'done' : 'default');
    const [fileName, setFileName] = useState(typeof file === 'string' ? id : (_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : '');
    const [fileSize, setFileSize] = useState(file instanceof File ? file.size : 0);
    const formatFileSize = (bytes) => {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2)).toString()} ${sizes[i]}`;
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        if (!disabled && state !== 'loading')
            setState('hover');
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        if (!disabled && state !== 'loading')
            setState(fileName ? 'done' : 'default');
    };
    const handleDrop = (e) => {
        e.preventDefault();
        if (disabled || state === 'loading')
            return;
        const file = e.dataTransfer.files[0];
        processFile(file);
    };
    const handleSelect = () => {
        var _a;
        if (!disabled && state !== 'loading')
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleFileInputChange = (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            processFile(file);
        }
        e.target.value = '';
    };
    const processFile = (file) => {
        var _a, _b, _c;
        if (file.size > ((_a = rules === null || rules === void 0 ? void 0 : rules.maxSizeMB) !== null && _a !== void 0 ? _a : 10) * 1024 * 1024) {
            setState('error-weight');
            setFileName('');
            setFileSize(0);
            return;
        }
        const acceptList = (_c = (_b = rules === null || rules === void 0 ? void 0 : rules.accept) === null || _b === void 0 ? void 0 : _b.map((f) => f.trim())) !== null && _c !== void 0 ? _c : [];
        const isValidType = acceptList.some((type) => {
            if (type.startsWith('.')) {
                return file.name.toLowerCase().endsWith(type.toLowerCase());
            }
            else {
                return file.type === type;
            }
        });
        if (!isValidType) {
            setState('error-file');
            setFileName('');
            setFileSize(0);
            return;
        }
        setFileName(file.name);
        setFileSize(file.size);
        setState('loading');
        void onFileChange(file)
            .then(() => {
            setState('done');
        })
            .catch(() => {
            setState('error-execution');
            setFileName('');
            setFileSize(0);
        });
    };
    const handleRemove = () => {
        setFileName('');
        setFileSize(0);
        setState('default');
        if (onRemove)
            onRemove();
    };
    return (_jsxs(Container, { "$state": state, "$disabled": disabled, "$aiScrapper": aiScrapper, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, children: [_jsxs(IconContainer, { "$state": state, "$aiScrapper": aiScrapper, children: [state === 'default' &&
                        (aiScrapper ? (_jsx(SparklesIcon, { size: 32, color: MDS_COLORS_INK_RECOMMENDATION })) : (_jsx(UploadOutlineIcon, { size: 32, color: MDS_COLORS_INK_DEFAULT }))), state === 'hover' && (_jsx(PaperDownloadOutlineIcon, { size: 32, color: aiScrapper ? MDS_COLORS_INK_RECOMMENDATION : MDS_COLORS_INK_ACCENT_HOVER })), state === 'loading' && (_jsx(Loader, { fullscreen: false, spinnerIconProps: { size: 32, color: aiScrapper ? MDS_COLORS_INK_RECOMMENDATION : MDS_COLORS_INK_WEAK } })), (state === 'error-weight' || state === 'error-file' || state === 'error-execution') && (_jsx(CircleAlertOutlineIcon, { size: 32, color: MDS_COLORS_INK_ERROR })), state === 'done' && _jsx(CheckInsideCircleOutlineIcon, { size: 32, color: MDS_COLORS_INK_POSITIVE })] }), _jsxs(ContentContainer, { "$state": state, "$aiScrapper": aiScrapper, children: [_jsxs(FlexContainer, { direction: "column", children: [_jsxs(Label, { component: "caption1", "$state": state, "$aiScrapper": aiScrapper, children: [state === 'hover' && text.hoverText, state === 'error-file' && text.errorFileText, state === 'error-weight' && text.errorWeightText, state === 'error-execution' && text.errorExecutionText, state === 'loading' && aiScrapper && text.loadingTextAiScrapper, (state === 'default' || state === 'done' || (state === 'loading' && !aiScrapper)) && label] }), (state === 'default' || state === 'error-file' || state === 'error-weight') && (_jsxs(FlexContainer, { direction: "column", children: [_jsxs(Typography, { component: "caption2", color: state === 'error-file' ? 'mds-colors-ink-error' : 'mds-colors-ink-default', children: ["Formatos: ", _jsx("b", { children: (_b = rules === null || rules === void 0 ? void 0 : rules.accept) === null || _b === void 0 ? void 0 : _b.join(', ').toUpperCase() })] }), _jsxs(Typography, { component: "caption2", color: state === 'error-weight' ? 'mds-colors-ink-error' : 'mds-colors-ink-default', children: ["Peso m\u00E1ximo: ", _jsxs("b", { children: [rules === null || rules === void 0 ? void 0 : rules.maxSizeMB, " MB"] })] })] })), state === 'loading' && (_jsx(Typography, { component: "caption2", color: "mds-colors-ink-weak", children: text.loadingText })), state === 'done' && (_jsxs(FlexContainer, { direction: "column", children: [_jsx(Typography, { component: "caption2", color: "mds-colors-ink-positive", children: fileName }), fileSize > 0 && (_jsx(Typography, { component: "caption2", color: "mds-colors-ink-weak", children: formatFileSize(fileSize) }))] }))] }), state !== 'hover' && (_jsxs(FlexContainer, { width: "max-content", children: [fileName && (_jsx(CloseButton, { disabled: disabled, onClick: handleRemove, children: _jsx(CancelCircleIcon, { size: 24 }) })), !fileName && (_jsxs(_Fragment, { children: [_jsx(Button, { text: text.selectButtonText, onClick: handleSelect, disabled: disabled, variant: "primary" }), _jsx("input", { ref: inputRef, type: "file", style: { display: 'none' }, onChange: handleFileInputChange, accept: (_c = rules === null || rules === void 0 ? void 0 : rules.accept) === null || _c === void 0 ? void 0 : _c.join(','), disabled: disabled })] }))] }))] })] }));
};
export default FileUploaderInline;
